import { render, staticRenderFns } from "./ForgottenPasswordDialog.vue?vue&type=template&id=0080d666"
import script from "./ForgottenPasswordDialog.vue?vue&type=script&lang=js"
export * from "./ForgottenPasswordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports